// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"2412a518","49":"93b180c2","134":"cbb2cca6","241":"e066ae67","382":"192ea860","674":"ebe520a6","762":"62377b98","916":"7de641d4","956":"21b7d5fd"}[chunkId] + ".css";
};